export default __webpack_public_path__ + "static/stacked-column-3e73fd12e7d10871df53858c5b932063.png";